<template>
	<div>
		<header>
	        <i></i>
	        <a class="back" href="javascript:;">东方号</a>
	    </header>
	    <div class="protocol">
	        <p>&nbsp;&nbsp; &nbsp;&nbsp;欢迎阅读用户服务条款协议，本协议阐述之条款和条件适用于自媒体平台（http://mp.tt.cn/）（以下简称“东方号”）与其入驻用户的服务约定，本用户服务协议具有合同效力。本用户服务协议内容包括本协议正文及东方号已经发布的或将来可能发布的各类规则、声明等各项规范平台运营及明确本公司和用户权利义务、责任的文件资料。所有规则、声明等均为本用户服务协议不可分割的一部分，与本用户服务协议具有同等法律效力。<br/></p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;本用户服务协议宗旨是为了更好的规范东方号运营管理，为广大用户提供一个安全、绿色、健康的网络环境，保护网络信息安全，保障公民、法人和其他组织的合法权益，维护国家安全和社会公共利益，上海嵩智文化传播有限公司（以下简称“上海嵩智”）根据国家法律法规以及相关规定，制定本协议；<br/></p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;(1) 东方号在运营中，将按照本协议的有关条款提供网络服务。<br/></p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;(2) 用户应当充分阅读并同意本协议的全部条款并按照页面上的提示完成全部的注册程序，用户在注册过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款，用户在访问上海嵩智及东方头条网页阅读新闻、登录东方号进行相关内容活动时，将视为同意接受本协议全部条款的约束，如果用户不同意本用户协议的内容，则不能获得使用东方号服务以及注册成为东方号用户的权利。<br/></p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;(3) 东方号保留在任何时候修改本协议条款的权利，且无需另行通知。用户在使用服务时应关注并遵守。<br/></p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;(4) 如用户对本协议以及本协议的修改有异议，可通过但不限于书信、电话、电子邮件等说明，明确表示不接受本协议以及本协议的修改，或确已停止使用东方号的服务，如用户继续使用东方号账号登录东方号，则视接受本协议全部内容。<br/></p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第一部分 账号申请与使用</p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;1、账号：用户通过在东方号平台上注册账号，通过账号登录，在东方号进行相关的活动，东方号账号共分为自媒体个人账号（自然人）和企、事业单位用户账号（法人）、非法人组织三大类；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、申请与审核：用户在申请注册东方号登录账号时，需提交真实、有效且合法的相关身份证明材料，按照页面相关步骤进行注册申请，并对提交资料信息的真实性和合法性负责。账号审核中，上海嵩智有权核查用户提交的相关材料，含自媒体人用户申请提交的身份证复印件；企、事业单位、非法人组织用户申请提交的企业法人营业执照副本复印件、事业单位法人证书复印件、法定代表人身份证复印件、法人和非法人组织官方声明/说明等信息，上海嵩智对资料真伪进行审核后，再决定是否核准通过用户的注册申请，如申请资料有任何变动，必须及时更新；<span style="color: #f84e4e;">注意：账号实际运营人应与提交的身份信息相一致，平台有权对实际运营人信息进行检查，如发现异常，将暂停该注册账号在本平台的运营、提现等行为。</span><br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、使用及权限：注册申请审核通过后，用户将获得所申请的东方号账号的使用权，可以登录并在平台上发布内容；通过账号后台了解账号订阅用户量及消息点击次数等数据；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;4、属性与管理：平台账号的所有权归上海嵩智所有，禁止任何赠与、借用、租用、转让或售卖账号等行为；用户应妥善管理好账号以及密码，由于用户过错或第三方技术原因导致账号被他人非法使用的，用户应该立即通知上海嵩智并配合协助处理，由此导致账号的任何安全问题和法律问题，上海嵩智不承担任何责任。<br/>
                    </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第二部分 信息安全保护</p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;1、上海嵩智将建立健全东方号用户信息安全管理制度，按照法律相关规定保障用户信息安全。未经用户同意，不会向其他任何公司、组织或个人披露用户个人信息，法律法规另有规定的除外；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、为了更好地提供服务和帮助、保护用户合法权益，用户申请注册时所提供的信息须保证是真实、准确、合法、有效的，并注意及时更新，以免在使用过程中受到限制或无法使用； <br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、用户在使用东方号账号和登录东方号平台过程中，禁止以搜集、复制、存储、传播等任何方式使用其他用户的个人信息，否则，东方号有权进行封号处理，由此产生的后果需用户自行承担。<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第三部分 使用规则 </p>
                <p>&nbsp;&nbsp; &nbsp;&nbsp;1、使用规则适用于依托东方号平台，以东方号为载体发生的或通过其账号发生的一切活动和事件包括但不限于注册登录、账号运营推广以及其他使用东方号账号或东方号所进行的行为；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、用户在使用东方号服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用东方号账号和东方号平台进行任何违法或不正当的活动，包括但不限于下列行为：<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(1) 提交、发布虚假信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(2) 冒充、利用他人名义发布信息的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(3) 冒用他人作品；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(4) 强制、诱导其他用户关注、点击链接页面或分享信息的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(5) 虚构事实、隐瞒真相以误导、欺骗他人的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(6) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(7) 未经上海嵩智书面许可利用东方号开放账号对第三方运营平台进行推广或互相推广的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(8) 未经上海嵩智许可使用插件、外挂或其他第三方工具、服务接入本服务和相关系统；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(9) 利用东方号账号或东方号平台从事任何违法犯罪活动的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(10) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(11) 其他违反法律法规规定、侵犯其他用户合法权益、干扰平台正常运营或上海嵩智未明确授权的行为。<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第四部分 内容规范</p>
                <p>
                    &nbsp;&nbsp; &nbsp;&nbsp;1、东方号发布的内容是指使用东方号平台过程中所制作、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及其他资料，或文字、语音、图片、视频、图文等发送、回复消息和相关链接页面，以及其他使用东方号账号或东方号平台所产生的内容；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、用户注册东方号成功后，请用户管理好自己的账号，遵守本协议的各项条款，并妥善管理和使用账号相关权限，对使用账号在东方号平台上传、发布的内容，包括但不限于文章文字、评论观点、视频音频、照片表情符号等内容享有合法权益，若发布的内容发生权利纠纷或侵犯任何第三方的合法权益等，用户需承担相应的法律责任；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、用户发布的的内容不能与国家法律法规相悖。此外，为维护东方号的正常运营及用户的良好体验，用户不能发布低俗、涉及他人隐私、以及纯粹商业广告等内容。包括但不限于如下：<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(1) 反对宪法所确定的基本原则的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(3) 损害国家荣誉和利益的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(4) 煽动民族仇恨、民族歧视，破坏民族团结的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖信息或者教唆犯罪的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(8) 侮辱或者诽谤他人，侵害他人合法权益的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(9) 含有任何性或性暗示以及任何其他低俗类信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(10) 骚扰、垃圾广告；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(11) 涉及他人隐私、个人信息或资料的任何信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(12) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的任何信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(13) 含有法律、行政法规禁止的其他内容的；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;(14) 含其他干扰东方号正常运营、侵犯其他用户合法权益内容的信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;4、上海嵩智文化传播有限公司是东方号及其涉及到的产品、标识、相关软件的所有权及知识产权权利人。上述知识产权包括但不限于程序代码、界面设计、版面框架、数据资料、帐号、文字、图片、图形、图表、音频、视频、商业标识等，除按照法律法规规定应由相关权利人享有权利的内容以外。<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;5、若用户需对内容创作衍生品或投放商业广告，需向上海嵩智文化传播有限公司另行提交书面申请，并遵守上海嵩智关于上述业务的相关规定及要求。<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;6、为维护东方号的稳定运营，确保用户体验质量，未经东方号事先书面许可，任何人不得擅自在东方号上实施自动化行为或发布垃圾信息；自动化行为，是指以用户自行或委托他人采用自动化手段或明显异于常人的、远高于正常用户频率地发布文章、信息、评论、私信、头条文章或作出关注、点赞、抓取数据等的行为；垃圾信息，是指未经东方号同意，擅自使用东方号（包括通过作弊手段批量注册的东方号、普通东方号等）在文章、信息、评论、私信、帐号信息、头条文章、群聊内容中发布的营销信息、无意义信息或卖粉信息；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;7、用户知悉并同意，东方号有权根据技术规则通过检测验证等方式判断用户帐号行为是否构成自动化行为、用户帐号所发布的信息是否为垃圾信息，并采取相关措施予以处理。所有处理措施所依据的数据及信息（包括但不限于帐号操作记录、文章内容、转评赞等）均以东方号后台记录为准。<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第五部分 知识产权 </p>
                <p>
                    &nbsp;&nbsp; &nbsp;&nbsp;1、用户同意其在东方号上发布的内容，包括但不限于文字、图片、视频、音频等，不论其内容是否构成著作权法意义上的可保护客体，用户应保证其为原创著作权人或已取得合法授权或转授权权利，并且该内容不会侵犯任何第三方的合法权益；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、用户同意授予东方号所有上述内容在全球范围内的免费、不可撤销的、无期限限制的、可再许可或转让的非独家使用权许可，据该许可东方号将有权以展示、推广及其他不为我国法律所禁止的方式使用前述内容；<br/>
                    </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第六部分 维权约定 </p>
                <p>
                   	 &nbsp;&nbsp; &nbsp;&nbsp;用户授权上海嵩智文化传播有限公司就其他方侵犯用户作品著作权的行为（包括但不限于复制、使用、编辑、抄袭、第三方平台发布等行为）采取任何形式的维权行为，包括但不限于投诉、诉讼等必要的维权措施，用户同意上海嵩智文化传播有限公司可以自行转授权上述权利。用户承诺积极配合上海嵩智文化传播有限公司行使上述权利，并按照上海嵩智文化传播有限公司要求提供相应的证明文件及必要的协助。上海嵩智文化传播有限公司因行使维权权利产生的一切收益，扣除维权行为中产生的一切费用后，余下部分归用户所有<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第七部分 法律责任 </p>
                	&nbsp;&nbsp; &nbsp;&nbsp;1、如果上海嵩智发现或收到他人举报或投诉东方号用户违反本协议约定的，上海嵩智有权随时对相关内容进行删除，并视行为情节对违规账号处以包括但不限于警告、删除部分或全部订阅用户、限制或禁止使用全部或部分功能、账号封禁直至注销的处罚，并公告处理结果；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、用户理解并同意，上海嵩智有权依合理判断对违反东方号规定的用户进行处罚，如发现有违法违规等情况，有权并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、用户理解并同意，因用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当承担全部责任并赔偿上海嵩智与合作公司、关联公司的全部损失；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;4、用户应保证其合法合规使用东方号服务，不得进行自动化行为、发布垃圾信息、恶意刷评论、批量注册、自动回复，不得在东方号中植入木马，强制、强行以非正常手段或东方号以及上海嵩智不认可的方式使用东方号服务，由于用户行为不适当、不合法等给东方号或者上海嵩智给造成损失的，用户应进行赔偿，包括但不限于实际损失、可得利益损失、诉讼费、律师费等。<br/>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第八部分 自律条款 </p>
                <p>
                	&nbsp;&nbsp; &nbsp;&nbsp;用户在使用东方号服务时应遵守法律法规以及本协议相关约定、文明上网、遵循公序良俗，创造健康有序的网络空间、弘扬社会主义核心价值观、弘扬中华传统美德。
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第九部分 免责声明 </p>
                <p>
                    &nbsp;&nbsp; &nbsp;&nbsp;1、用户直接或通过各类方式（如站外API引用等）间接使用东方号服务和数据的行为，都将被视作已无条件接受本声明所涉全部内容；若用户对本声明的任何条款有异议，请停止使用东方号所提供的全部服务。<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、东方号仅为用户发布的内容提供存储空间，东方号不对用户发表、转载的内容提供任何形式的保证：不保证东方号的服务不会中断。因网络状况、通讯线路、第三方网站或管理部门的要求等任何原因而导致用户不能正常使用东方号，东方号不承担任何法律责任。<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、用户在东方号发表的内容（包含但不限于东方号目前各产品功能里的内容）仅表明其个人的立场和观点，并不代表东方号的立场或观点。用户作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。东方号不承担任何法律及连带责任。<br/>
                	&nbsp;&nbsp; &nbsp;&nbsp;4、用户在东方号发布侵犯他人知识产权或其他合法权益的内容，东方号有权予以删除，并保留移交司法机关处理的权利。<br/>
                	&nbsp;&nbsp; &nbsp;&nbsp;5、任何个人或单位如认为东方号上存在侵犯自身合法权益的内容，应准备好具有法律效力的证明材料，及时与东方号取得联系，以便东方号迅速做出处理。<br/>
                	&nbsp;&nbsp; &nbsp;&nbsp;6、上海嵩智在接到第三方对东方号内容的投诉后，经评估若发现内容可能涉及侵权，上海嵩智有权直接将内容删除、屏蔽；用户若对上海嵩智的删除决定不服，可以向上海嵩智提出恢复内容申请，申请中需对第三方的投诉做出合理解释并提供相应的证明材料；上海嵩智对用户的申请进行评估后，有权决定是否将删除的内容恢复。<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第十部分 生效与变更  </p>
                <p>
                    1、用户使用本服务即视已阅读并同意受本协议的约束；<br/>
                    2、上海嵩智有权在必要时修改本协议条款。用户可以在相关服务页面查阅最新版本的协议条款；<br/>
                    3、本协议条款变更后，如果用户继续使用东方号服务，即视为用户已接受修改后的协议，如果用户不接受修改后的协议，应当停止使用东方号服务。<br/>
                </p>
                <p class="mt20 f16 fb">&nbsp;&nbsp; &nbsp;&nbsp;第十一部分 其他  </p>
                <p>
                    &nbsp;&nbsp; &nbsp;&nbsp;1、本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;2、本协议签订地为中华人民共和国上海市浦东新区；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;3、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;4、若用户和上海嵩智文化传播有限公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，争议中任何一方均有权将纠纷或争议向本协议签订地有管辖权的人民法院提起诉讼；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;5、本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束；<br/>
                    &nbsp;&nbsp; &nbsp;&nbsp;6、上海嵩智文化传播有限公司对本使用协议享有最终解释权。<br/>
                    <br/>
                    	
                </p>
				<p style="text-align:right">
					上海嵩智文化传播有限公司 &nbsp;&nbsp; &nbsp;&nbsp;<br/>
					<br/>
                    	2018年3月8日  &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;<br/>
				</p>
	    </div>
	    
	    <footer class="b-default copyright">
	        <p>©上海嵩智文化传播有限公司（tt.cn）版权所有</p>
	    </footer>
	</div>
</template>
<script>
	export default {
		name: 'RegistData',
		data (){
			return {

			}
		}
	}
</script>
<style scoped>
	@import "./../common/css/reg.css";
	@import "./../common/css/h5Base.css";
	.protocol{
    	padding: .2rem .3rem 0;
		font-size: 0.24rem;
		text-align: left;
	}
    .protocol .mt20{
        text-align: center;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/protocol.vue